import { useContext, useCallback, useState, useEffect, useMemo } from "react";
import "./DashboardOcorrencias.css";
import LoadingComponent from "../../../../components/LoadingComponent/LoadingComponent.tsx";
import { getOcorrenciaSearch } from "../../../../services/ModuloGerenciador/Search";
import { motion } from "framer-motion";
import MultiplosFiltrosRedux from "../../../../contexts/MultiplosFiltros";
import NavbarV3 from "../../../../components/NavbarV3/NavbarV3.tsx";
import FiltroV2 from "../../../../components/FiltroV2/FiltroV2";
import TabelaOcorrenciasDash from "../../../../components/TabelaOcorrenciasDash/TabelaOcorrenciasDash";
import { useProfile } from "../../../../contexts/ProfileContext.tsx";
import MotionSemAutorizacao from "../../../../core/components/MotionSemAutorizacao.tsx";
import {
	primeiroDiaDosMesFormatado,
	ultimoDiaDosMesFormatado,
} from "../../../../core/utils/UtilityDates.ts";

const itensFiltro = [
	{
		nomeColuna: "Ocorrência",
		field: "ocorrencia",
	},
	{
		nomeColuna: "Tipo Ocorrência",
		field: "tipoOcorrencia",
	},
	{
		nomeColuna: "Sub Tipo Ocorrência",
		field: "subTipoOcorrencia",
	},
	{
		nomeColuna: "Data Ocorrência",
		field: "dataOcorrencia",
	},
	{
		nomeColuna: "Observação",
		field: "observacao",
	},
];

function DashboardOcorrencias() {
	const { profile, hasRegra, tabelaEmpresa } = useProfile();

	const { multiplosFiltrosRedux } = useContext(MultiplosFiltrosRedux);

	const [semAutorizacao, setSemAutorizacao] = useState(true);

	const [loading, setLoading] = useState(true);

	const [valuesPesquisa, setValuesPesquisa] = useState([]);

	const [dadosTabela, setDadosTabela] = useState([]);

	const [dadosTabelaCopiaFiltro, setDadosTabelaCopiaFiltro] = useState([]);

	const converterData = (data) => {
		const parts = data.split("-");
		return `${parts[2]}-${parts[1]}-${parts[0]}`;
	};

	const buscarSearch = useCallback(
		async (ordenarPor) => {
			if (!profile) return;

			setLoading(true);
			var date = new Date();
			var primeiroDia = new Date(date.getFullYear(), date.getMonth(), 1)
				.toLocaleDateString("pt-BR", {
					year: "numeric",
					month: "numeric",
					day: "numeric",
				})
				.replace(/\//g, "-");
			var ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0)
				.toLocaleDateString("pt-BR", {
					year: "numeric",
					month: "numeric",
					day: "numeric",
				})
				.replace(/\//g, "-");
			const data1 = converterData(primeiroDia);
			const data2 = converterData(ultimoDia);

			let pesquisaFormatada = `${valuesPesquisa.item}=${valuesPesquisa.pesquisa}`;
			if (multiplosFiltrosRedux && multiplosFiltrosRedux.length > 0) {
				for (let filtro of multiplosFiltrosRedux) {
					pesquisaFormatada += `&${filtro.field}=${filtro.valor}`;
				}
			}
			await getOcorrenciaSearch({
				token: profile?.token,
				pesquisa: pesquisaFormatada,
				dataInicio: valuesPesquisa.embarqueInicio
					? valuesPesquisa.embarqueInicio
					: data1,
				dataFim: valuesPesquisa.embarqueFinal
					? valuesPesquisa.embarqueFinal
					: data2,
				ordenarPor,
			})
				.then((result) => {
					setDadosTabela(result.data);
					setDadosTabelaCopiaFiltro(result.data);
				})
				.catch((error) => {});
			setLoading(false);
		},
		[profile, valuesPesquisa, multiplosFiltrosRedux]
	);

	const limpar = () => {
		setLoading(true);
		setValuesPesquisa([]);
		setDadosTabela(dadosTabelaCopiaFiltro);
		setLoading(false);
	};

	useEffect(() => {
		if (profile?.token) {
			buscarSearch();
			setSemAutorizacao(!hasRegra("Dashboard"));
		}
	}, [profile?.token]);

	const isLoading = useMemo(() => {
		return loading || !profile?.token || !dadosTabela;
	}, [loading, dadosTabela, profile?.token]);

	if (semAutorizacao) {
		return <MotionSemAutorizacao />;
	}

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			<NavbarV3 title="Dashboard Ocorrências" />
			{isLoading && <LoadingComponent />}
			{!isLoading && (
				<motion.div
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0 }}
				>
					<div className="dash-ocorrencias">
						<FiltroV2
							classe="div-filtrar-embarque-v2"
							classOption="select-options"
							itensFiltro={itensFiltro}
							valuesPesquisa={valuesPesquisa}
							setValuesPesquisa={setValuesPesquisa}
							buscarSearch={buscarSearch}
							limpar={limpar}
						/>
						<TabelaOcorrenciasDash
							colunas={tabelaEmpresa.OcorrenciaEmbarque}
							dados={dadosTabela}
							buscarSearch={buscarSearch}
						/>
					</div>
				</motion.div>
			)}
		</motion.div>
	);
}
export default DashboardOcorrencias;
